import{persist as r}from"../index.js";function s(s={}){return t=>(r(Object.assign({store:t},s)),t)}export{s as persist};
//# sourceMappingURL=index.js.map
